<template>
  <div>
    <v-dialog persistent v-model="dialog_bulk_grade" max-width="800px">
      <v-card class="card-shadow border-radius-xl">
        <div class="card-header-padding card-border-bottom">
          <span class="font-weight-bold text-h5 text-typo mb-0">New Grade</span>
        </div>
        <v-card-text class="card-padding">
          <v-container class="px-0">
            <v-form ref="frm">
              <v-row
                justify="center"
                v-for="(row, i) in editedItem.bulk.length"
                v-bind:key="i"
              >
                <v-col cols="4">
                  <label class="text-md text-typo font-weight-bolder ms-1"
                    >Grade Name</label
                  >
                  <v-text-field
                    v-model="editedItem.bulk[i].grade_name"
                    hide-details="auto"
                    class="
                      input-style
                      font-size-input
                      text-light-input
                      placeholder-light
                      input-icon
                    "
                    dense
                    flat
                    filled
                    solo
                    placeholder="Grade"
                    :rules="[(v) => !!v || 'Grade name is required']"
                  ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <label class="text-md text-typo font-weight-bolder ms-1"
                    >Grade code</label
                  >
                  <v-text-field
                    @keyup="capitalize(i)"
                    v-model="editedItem.bulk[i].grade_code"
                    hide-details="auto"
                    class="
                      input-style
                      font-size-input
                      text-light-input
                      placeholder-light
                      input-icon
                    "
                    dense
                    flat
                    filled
                    solo
                    placeholder="Grade code"
                    :rules="[(v) => !!v || 'Code is required']"
                  ></v-text-field>
                </v-col>
                <v-col cols="2" class="pa-1" align-self="center">
                  <span class="pa-2" align-self="center">
                    <v-btn
                      class="mx-2 mt-3 input-style"
                      outlined
                      small
                      color="red"
                      @click="remove(i)"
                      v-show="i || (!i && editedItem.bulk.length > 1)"
                      >Remove
                    </v-btn>
                  </span>
                </v-col>
                <v-col cols="2" class="pa-1" align-self="center">
                  <span class="pa-2" align-self="center">
                    <v-btn
                      class="mx-2 mt-3"
                      outlined
                      small
                      color="green"
                      @click="add()"
                      v-show="i == editedItem.bulk.length - 1"
                      >Add
                    </v-btn>
                  </span>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>

        <v-card-actions class="card-padding d-flex justify-end">
          <v-btn
            @click="cancel"
            elevation="0"
            :ripple="false"
            height="43"
            class="
              font-weight-bold
              text-capitalize
              btn-ls btn-secondary
              bg-gradient-light
              py-3
              px-6
            "
            >Cancel</v-btn
          >

          <v-btn
            @click="save"
            elevation="0"
            :ripple="false"
            height="43"
            dark
            class="text-capitalize btn-ls btn-primary bg-success py-3 px-6"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
// import axios from "axios";
import api from "../api";

export default {
  props: {
    input_data: Array,
    dialog_bulk_grade: Boolean,
  },
  name: "GradeBulk",
  data() {
    return {
      editedItem: {
        bulk: [{ grade_name: "", grade_code: "" }],
      },
      defaultItem: {
        bulk: [{ grade_name: "", grade_code: "" }],
      },
    };
  },

  created() {
    this.initialize();
  },

  methods: {
    async initialize() {
      if (
        this.input_data &&
        this.input_data?.length > 0 &&
        this.input_data != undefined &&
        this.input_data != null
      ) {
        this.editedItem.bulk = this.input_data;
      }
    },

    validate() {
      return this.$refs.frm.validate();
    },

    add() {
      this.editedItem.bulk.push({
        grade_name: "",
        grade_code: "",
      });
    },

    remove(index) {
      this.editedItem.bulk.splice(index, 1);
    },
    showSuccessAlert(message) {
      this.$swal({
        title: "Success",
        text: message,
        type: "success",
        timer: 3000,
        icon: "success",
        showConfirmButton: false,
      });
    },

    showErrorAlert(message) {
      this.$swal({
        title: "Error",
        text: message,
        type: "error",

        icon: "error",
        showConfirmButton: true,
      });
    },

    cancel() {
      // console.log("Cancceled");
      this.$emit("cancel_upload");
    },

    close() {
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
      this.$emit("close_dialog_bulk_grade");
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    capitalize(i) {
      this.editedItem.bulk[i].grade_code =
        this.editedItem.bulk[i].grade_code.toUpperCase();
    },
    async save() {
      if (this.validate()) {
        try {
          let type = "Saved";
          await api.createBulk(this.editedItem);
          this.showSuccessAlert(`Grades ${type}.`);
          this.close();
        } catch (err) {
          this.showErrorAlert(err.message);
        }
      }
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Grade" : "Edit Grade";
    },
  },
};
</script>
